import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  borderRadius,
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = css`
  position: relative;
  padding-bottom: ${size[24]};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto ${size[32]};

  ${breakpoint.up('smMd')} {
    padding-bottom: 0;
  }
`

export const container = css`
  padding: ${size[24]} ${size[24]} 0;
  width: 100%;

  ${breakpoint.up('smMd')} {
    max-width: ${width.container.wide};
    padding: ${size[24]};

    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  max-width: ${width.modal.compact};
  margin-top: ${size[24]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
    text-align: center;
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const description = css`
  margin: ${size[24]} 0 0;
  font-size: ${fontSize.md};
  line-height: ${size[24]};

  ${breakpoint.up('smMd')} {
    margin-top: ${size[40]};
    text-align: center;
  }
`

export const sliderWrapper = css`
  width: 100%;
  overflow-x: hidden;
  padding-left: ${size[24]};
  margin-top: ${size[32]};

  ${breakpoint.up('smMd')} {
    padding-left: calc((100vw - ${width.container.wider}) / 2);
    margin-top: ${size[64]};
  }
`

export const slider = css`
  display: flex;
  align-items: center;
  gap: ${size[24]};
  overflow-x: auto;
  width: 100%;
  padding-right: ${size[24]};

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${breakpoint.up('smMd')} {
    gap: ${size[32]};
    padding: 0 ${size[24]};
  }
`

export const imageBox = (theme: Theme) => css`
  flex-basis: 250px;
  flex-shrink: 0;
  border: 1px solid ${theme.palette.overlay.main};
  border-radius: ${theme.borderRadius.md};
  padding: ${size[12]};
  display: flex;
  flex-direction: column;
  gap: ${size[28]};

  ${breakpoint.up('smMd')} {
    flex-basis: 340px;
    border-radius: ${theme.borderRadius.lg};
    padding: ${size[20]};
    gap: ${size[40]};
  }
`

export const cta = css`
  display: flex;
  flex-direction: column;
  gap: ${size[8]};

  ${breakpoint.up('smMd')} {
    gap: ${size[12]};
  }
`

export const sliderButton = (theme: Theme) => css`
  position: absolute;
  top: 60%;
  left: ${size[32]};
  width: ${size[60]};
  height: ${size[60]};
  transform: translateY(-50%);
  z-index: 1;
  background-color: ${theme.palette.background.main};
  border: none;
  border-radius: ${borderRadius.circle};
  box-shadow: ${theme.shadows.defaultActive};
  cursor: pointer;

  :hover {
    background-color: ${theme.palette.background.accent};
  }

  svg {
    width: ${size[24]};
    height: ${size[24]};
  }
`

export const next = css`
  left: initial;
  right: ${size[32]};

  svg {
    transform: rotate(180deg);
  }
`
